import { downloadBlob } from "~/utilities/element"

/**
 * Spreadsheet apps execute cells that start with a formula character, and names are entered by students.
 * A leading plus or minus is left alone when the rest is a plain number, so phone numbers stay readable.
 */
function toCsvCell(value: string): string {
	const safeValue = /^[=@\t\r]|^[+-](?![\d\s()]*$)/.test(value) ? `'${value}` : value
	return `"${safeValue.replaceAll('"', '""')}"`
}

export type CsvColumn<T> = { title: string; value(row: T): string }

export function downloadCsv<T>(fileName: string, columns: CsvColumn<T>[], rows: T[]) {
	const csv = [
		columns.map(column => toCsvCell(column.title)).join(","),
		...rows.map(row => columns.map(column => toCsvCell(column.value(row))).join(",")),
	].join("\r\n")

	downloadBlob(new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" }), fileName)
}
